import { PERMISSION } from '@/app/permissions';
import { MEASURE_STATUS } from '@/features/publicsite/catalog/measureStatus';
import type { Measure } from '@/features/publicsite/types/funding/Measure';

/**
 * The permission filing an application needs, which RequirePermission also guards
 * /app/finantare/aplicare with. The backend demands this one and applications.submit:own
 * together on POST .../applications; the matrix grants both to the same three roles, so the
 * first is enough to decide whether the card leads anywhere.
 */
export const APPLY_PERMISSION = PERMISSION.applicationsCreateOwn;

/**
 * Where a measure's card links, or null when it links nowhere and is drawn as a plain card.
 *
 * `permissions` is null for a visitor nobody has identified yet — signed out, or the session
 * bootstrap still in flight. Their link stays: MPass decides who they are, and reauth.ts stashes
 * the whole path including `?measure=`, so they land back on this measure once signed in. Taking
 * the link away from them instead would hide the call for applications from every anonymous
 * reader of a public catalogue.
 *
 * A signed-in account without the permission gets no link, for the reason a CLOSED measure gets
 * none: the route refuses them and the POST behind it answers 403, so the button could only lead
 * to a refusal.
 */
export function fundingApplyPath(
  measure: Pick<Measure, 'id' | 'status'>,
  permissions: readonly string[] | null,
): string | null {
  if (measure.status !== MEASURE_STATUS.open) return null;
  if (permissions !== null && !permissions.includes(APPLY_PERMISSION)) return null;
  return `/app/finantare/aplicare?measure=${measure.id}`;
}
